// Svenska län med postnummerområden (första siffran/siffrorna)
export const SWEDISH_REGIONS = [
  { code: 'AB', name: 'Stockholms län', postalPrefixes: ['1'] },
  { code: 'C', name: 'Uppsala län', postalPrefixes: ['74', '75'] },
  { code: 'D', name: 'Södermanlands län', postalPrefixes: ['61', '63', '64'] },
  { code: 'E', name: 'Östergötlands län', postalPrefixes: ['58', '59', '60'] },
  { code: 'F', name: 'Jönköpings län', postalPrefixes: ['33', '34', '56', '57'] },
  { code: 'G', name: 'Kronobergs län', postalPrefixes: ['35', '36'] },
  { code: 'H', name: 'Kalmar län', postalPrefixes: ['38', '39', '57'] },
  { code: 'I', name: 'Gotlands län', postalPrefixes: ['62'] },
  { code: 'K', name: 'Blekinge län', postalPrefixes: ['37'] },
  { code: 'M', name: 'Skåne län', postalPrefixes: ['2'] },
  { code: 'N', name: 'Hallands län', postalPrefixes: ['30', '31', '43'] },
  { code: 'O', name: 'Västra Götalands län', postalPrefixes: ['4', '44', '45', '46', '47', '51', '52', '53', '54'] },
  { code: 'S', name: 'Värmlands län', postalPrefixes: ['65', '66', '67', '68', '69'] },
  { code: 'T', name: 'Örebro län', postalPrefixes: ['70', '71'] },
  { code: 'U', name: 'Västmanlands län', postalPrefixes: ['72', '73'] },
  { code: 'W', name: 'Dalarnas län', postalPrefixes: ['77', '78', '79', '80'] },
  { code: 'X', name: 'Gävleborgs län', postalPrefixes: ['80', '81', '82'] },
  { code: 'Y', name: 'Västernorrlands län', postalPrefixes: ['85', '86', '87', '88'] },
  { code: 'Z', name: 'Jämtlands län', postalPrefixes: ['83', '84'] },
  { code: 'AC', name: 'Västerbottens län', postalPrefixes: ['90', '91', '92', '93'] },
  { code: 'BD', name: 'Norrbottens län', postalPrefixes: ['94', '95', '96', '97', '98'] },
];

export function getRegionFromPostalCode(postalCode: string): string | null {
  // Rensa postnummer från mellanslag och bindestreck
  const cleaned = postalCode.replace(/[\s-]/g, '');
  if (cleaned.length < 2) return null;
  
  // Kolla mot alla prefixer
  for (const region of SWEDISH_REGIONS) {
    for (const prefix of region.postalPrefixes) {
      if (cleaned.startsWith(prefix)) {
        return region.code;
      }
    }
  }
  return null;
}

export function getRegionName(code: string): string | undefined {
  return SWEDISH_REGIONS.find(r => r.code === code)?.name;
}

// Mappa interna regionkoder till Krisinformation.se county-koder
export const REGION_TO_COUNTY: Record<string, string> = {
  'AB': '01', // Stockholm
  'C': '03',  // Uppsala
  'D': '04',  // Södermanland
  'E': '05',  // Östergötland
  'F': '06',  // Jönköping
  'G': '07',  // Kronoberg
  'H': '08',  // Kalmar
  'I': '09',  // Gotland
  'K': '10',  // Blekinge
  'M': '12',  // Skåne
  'N': '13',  // Halland
  'O': '14',  // Västra Götaland
  'S': '17',  // Värmland
  'T': '18',  // Örebro
  'U': '19',  // Västmanland
  'W': '20',  // Dalarna
  'X': '21',  // Gävleborg
  'Y': '22',  // Västernorrland
  'Z': '23',  // Jämtland
  'AC': '24', // Västerbotten
  'BD': '25', // Norrbotten
};

export function getCountyCodeForRegion(regionCode?: string): string | undefined {
  if (!regionCode) return undefined;
  // Accept either internal region code (e.g. 'AB') or full region name ('Värmlands län')
  const key = regionCode.trim();
  // Direct lookup for code
  if (REGION_TO_COUNTY[key]) return REGION_TO_COUNTY[key];

  // Try to find by full region name (case-insensitive, normalize whitespace)
  const normalized = key.toLowerCase();
  const found = SWEDISH_REGIONS.find(r => r.name.toLowerCase() === normalized || r.name.toLowerCase().startsWith(normalized));
  if (found) return REGION_TO_COUNTY[found.code];

  // Also support values like 'Värmland' (without 'län') by checking startsWith
  const shortMatch = SWEDISH_REGIONS.find(r => r.name.toLowerCase().includes(normalized) || normalized.includes(r.name.toLowerCase()));
  if (shortMatch) return REGION_TO_COUNTY[shortMatch.code];

  return undefined;
}
